export default "__VITE_ASSET__XthUuxpXiyf13t3prDpdbw__"